export function obterListaMdfeRespSeguro() {
  return (
    [
      { label: '1 - Emitente do MDF-e', value: 'EMITENTE' },
      { label: '2 - Responsável pela contratação do serviço de transporte', value: 'CONTRATANTE' },
    ]
  );
}
